import type { InjectionKey } from 'vue'

export interface ParentPromotionTracking {
  parentPromotionName?: string
  parentHandlePromotionClick?: (suffix?: string) => void
}

export const ParentPromotionTrackingKey: InjectionKey<ParentPromotionTracking> = Symbol('ParentPromotionTracking')
